<template>
  <div class="month-container-250115">
    <el-calendar v-model="panelData.selectedDay" >
      <template #header="{ date }">
        <!-- <span>{{ date }}</span> -->
        <span>{{ getMonthLabel(+dayjs(props.month).format('MM')) }}</span>
      </template>
      <template #date-cell="{ data }">
        <div class="date-cell" :style="getCellStyle(data.day)">{{ +data.day.split('-').slice(2).join('-') }}</div>
      </template>
    </el-calendar>
  </div>
</template>

<script setup>
import { ref, reactive, inject,computed } from "vue"
import dayjs from 'dayjs';

const $str = window.$str;

const getRuleColorByDate = inject('getRuleColorByDate');


/** 属性传递：接收父组件传递下来的数据 */
const props = defineProps({
  month: {
    type: [Object, String],
    default: ''
  },
});


const panelData = reactive({
  selectedDay: new Date(props.month),
})








/** ====== [业务：功能方法] =================================================================== */

function getCellStyle(date) {
  const styleCfg = {
    '--cell-bg-color': '',
  };
  const cellBgColor = getRuleColorByDate(date);
  styleCfg['--cell-bg-color'] = cellBgColor;

  return styleCfg;
}




const isZh = computed(() => {
  const lang = String(localStorage.getItem('language') || '').toLowerCase();
  return !lang || lang === 'cn' || lang.startsWith('zh');
})

/** ====== [辅助：功能方法] =================================================================== */

function  getMonthEn(index){
  const monthEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return monthEn[index-1]
}

function getMonthLabel(index) {
  if (isZh.value) {
    return `${index}${$str.getKey('收益管理/月')}`;
  }
  return getMonthEn(index);
}




</script>
<style lang="scss" scoped>
.month-container-250115 {
  width: 100%;
  height: 100%;

  ::v-deep .el-calendar {
    width: 100%;
    height: 100%;
    .el-calendar__header {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .el-calendar__body {
      padding: 0px !important ;
      // 禁止鼠标事件
      pointer-events: none;
      // 禁止文本被选中
      user-select: none;
      -webkit-user-select: none; /* Safari */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */

      .el-calendar-table {
        .el-calendar-table__row {
          .current {
            .el-calendar-day {
              border: 1px solid #ecf5ff66;
            }
          }
          :not(.current) {
            .el-calendar-day {
              opacity: 0;
            }            
          }
        }
        .el-calendar-day {
          // width: 32px;
          height: 32px;
          margin: 2px;
          padding: 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          .date-cell {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: var(--cell-bg-color);
          }
        }
      }
    }
  }


  
}
</style>
